import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createEngine } from 'API/Engines/createEngine';

const useCreateEngine = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (engineData) => {
        const response = await createEngine(engineData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['Engines'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateEngine;
